import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { isNil } from 'lodash-es';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Invoice } from '~hooks/useInvoices/models';

interface TotalsHoursColumnProps {
  invoice: Invoice;
  sx?: SxProps<Theme>;
}

const TotalsHoursColumn = ({ invoice, sx }: TotalsHoursColumnProps) => {
  const { approvedWorkTimeMinutes, workTimeMinutes } = invoice.jobSummary ?? {};

  const workTime = approvedWorkTimeMinutes ?? workTimeMinutes;
  const totalHrs = isNil(workTime) ? null : `${((workTime ?? 0) / 60).toFixed(2)}h`;

  return (
    <Box sx={sx}>
      <OverflowAwareText>{totalHrs ?? '-'}</OverflowAwareText>
    </Box>
  );
};

export default TotalsHoursColumn;
